// @flow
import * as React from 'react';

import type { MessageType } from 'common/components/PageMessage';
import PageStylesV2 from './PageStylesV2';
import PageStylesV1 from './PageStylesV1';

type Message = {
  message: string,
  type: MessageType,
}

type Props = {
  title: string,
  fluid?: boolean,
  small?: boolean,
  hideTitle?: boolean,
  useThemeV2?: boolean,
  floatingComponents?: any,

  messages?: Message[],

  children: any,
  style?: Object,
  className?: string,
}

function Page({ useThemeV2, title, small, fluid, hideTitle, floatingComponents, children, style, className, messages }: Props) {
  const isFluid = fluid || false;
  const isSmall = (small || false) && !isFluid;
  const allMessages = messages || [];

  if (useThemeV2) {
    return (
      <PageStylesV2
        title={title}
        small={isSmall}
        fluid={isFluid}
        messages={allMessages}
        hideTitle={hideTitle}
        floatingComponents={floatingComponents}
        className={className}
        style={style}
      >
        {children}
      </PageStylesV2>
    );
  }

  return (
    <PageStylesV1
      title={title}
      small={isSmall}
      fluid={isFluid}
      messages={allMessages}
      hideTitle={hideTitle}
      floatingComponents={floatingComponents}
      className={className}
      style={style}
    >
      {children}
    </PageStylesV1>
  );
}

export default Page;



// WEBPACK FOOTER //
// ./src/statsradio/components/page/Page.js